import { Workbox } from 'workbox-window';

// SW is emitted by vite-plugin-pwa at build root then relocated to /passes/sw.js
// by scripts/move-passes-sw.mjs. Registering it from /passes/ lets the browser
// default-scope it to /passes/ without needing a Service-Worker-Allowed header.
const SW_URL = '/passes/sw.js';
const SW_SCOPE = '/passes/';

let registered = false;

export const registerPassesSW = () => {
  if (registered) return;
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return;

  registered = true;

  const wb = new Workbox(SW_URL, { scope: SW_SCOPE });

  wb.addEventListener('waiting', () => {
    // A new SW is waiting — activate it immediately. The passes app has no
    // long-running client state that would be disrupted by a swap.
    wb.messageSkipWaiting();
  });

  wb.addEventListener('controlling', () => {
    window.location.reload();
  });

  wb.register().catch((err) => {
    // eslint-disable-next-line no-console
    console.warn('[passes-pwa] service worker registration failed', err);
  });
};
